import styles from './ServiceRequestIcons.module.scss';

const SEND_ICON_SRC = '/images/service/online-service.png';
const BOUTIQUE_ICON_SRC = '/images/service/boutique-pickup.png';

const ICON_SIZE = 80;

type ServiceRequestIconProps = {
  className?: string;
};

export function ServiceRequestSendIcon({ className }: Readonly<ServiceRequestIconProps>) {
  return (
    <img
      src={SEND_ICON_SRC}
      alt=""
      width={ICON_SIZE}
      height={ICON_SIZE}
      className={className ?? styles.icon}
      decoding="async"
    />
  );
}

export function ServiceRequestBoutiqueIcon({ className }: Readonly<ServiceRequestIconProps>) {
  return (
    <img
      src={BOUTIQUE_ICON_SRC}
      alt=""
      width={ICON_SIZE}
      height={ICON_SIZE}
      className={className ?? styles.icon}
      decoding="async"
    />
  );
}
